/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:#ff6000!important;font-style:italic;text-decoration:underline!important;line-height:1rem}a[_ngcontent-%COMP%]:hover{cursor:pointer}a.compact[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:.8rem}a.compact[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{font-size:.4rem;margin-left:.2rem}a[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{font-size:.6rem;margin-left:.7rem}"];
export { styles as styles };
//# sourceMappingURL=arrow-link.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/arrow-link/arrow-link.component.scss.shim.ngstyle.js
// module id = 1453
// module chunks = 26 27 28